import { gql } from '@apollo/client'
import { BASE_QUESTION_FIELDS } from './question'

const VIDEO_FIELDS = gql`
  fragment VideoFields on VideoType {
    id
    title
    membershipLevel
    order
    link
    thumbnail
    videoLength
    isLive
    questionIds
    resourseURL
  }
`

const VIDEO_CATEGORY_FIELDS = gql`
  ${VIDEO_FIELDS}
  fragment VideoCategoryFields on VideoCategoryType {
    id
    createdAt
    updatedAt
    deletedAt
    version
    title
    subject {
      id
      slug
    }
    order
    description
    membershipLevel
    isLive
    author {
      id
      getAvatar {
        photo
      }
      fullName
    }
    chapterCompletionLive
    chapterCompletionTitle
    chapterCompletionDescription
    chapterCompletionBtn
    chapterCompletionBtnUrl
    chapterNotCompletionTitle
    chapterNotCompletionDescription
    chapterNotCompletionBtn
    chapterNotCompletionBtnUrl
    video {
      ...VideoFields
    }
  }
`

export const GET_LIST_VIDEO_CATEGORY = gql`
  ${VIDEO_CATEGORY_FIELDS}
  query findAllVideoCategory($query: VideoCategoryQueryInput = {}) {
    findAllVideoCategory(query: $query) {
      count
      items {
        ...VideoCategoryFields
      }
    }
  }
`

export const FIND_ONE_VIDEO_CATEGORY = gql`
  query findOneVideoCategory($findOneVideoCategoryId: String!) {
    findOneVideoCategory(id: $findOneVideoCategoryId) {
      id
      createdAt
      title
      isLive
      membershipLevel
      subject {
        id
        tabName
        slug
        type
        platform {
          id
        }
      }
      chapterCompletionLive
      chapterCompletionTitle
      chapterCompletionDescription
      chapterCompletionBtn
      chapterCompletionBtnUrl
      chapterNotCompletionTitle
      chapterNotCompletionDescription
      chapterNotCompletionBtn
      chapterNotCompletionBtnUrl
      video {
        id
        createdAt
        isLive
      }
    }
  }
`

export const FIND_ALL_VIDEOS = gql`
  query findAllVideo($query: VideoQueryInput! = {}) {
    findAllVideo(query: $query) {
      count
      items {
        id
        title
        resourseURL
        link
        membershipLevel
        history {
          updatedAt
          updatedBy
        }
        order
        createdAt
        isLive
      }
    }
  }
`

export const FIND_ONE_VIDEOS = gql`
  ${BASE_QUESTION_FIELDS}
  query findOneVideo($findOneVideoId: String!) {
    findOneVideo(id: $findOneVideoId) {
      id
      title
      resourseURL
      order
      createdAt
      isLive
      membershipLevel
      history {
        updatedAt
        updatedBy
      }
      link
      questionIds
      tags
      # TODO: use findQuestionByRelation instead of questions relation here
      questions {
        ...BaseQuestionFields
      }
    }
  }
`

export const CREATE_VIDEO = gql`
  mutation createVideo($createVideoInput: CreateVideoInput!) {
    createVideo(createVideoInput: $createVideoInput) {
      id
    }
  }
`

export const UPDATE_VIDEO = gql`
  mutation updateVideo($updateVideoInputFieldName: UpdateVideoInput!) {
    updateVideo(updateVideoInputFieldName: $updateVideoInputFieldName) {
      id
    }
  }
`

export const BULK_UPDATE_VIDEO = gql`
  mutation bulkUpdateVideo($input: [BulkUpdateVideoInput!]!) {
    bulkUpdateVideo(bulkUpdateVideoInput: $input) {
      id
    }
  }
`

export const REMOVE_VIDEO = gql`
  mutation removeVideo($removeVideoId: String!) {
    removeVideo(id: $removeVideoId) {
      affected
    }
  }
`

export const REMOVE_VIDEO_CATEGORY = gql`
  mutation removeVideoCategory($id: String!) {
    removeVideoCategory(id: $id) {
      affected
    }
  }
`

export const CREATE_VIDEO_CATEGORY = gql`
  mutation createVideoCategory($createVideoCategoryInput: CreateVideoCategoryInput!) {
    createVideoCategory(createVideoCategoryInput: $createVideoCategoryInput) {
      id
    }
  }
`

export const UPDATE_VIDEO_CATEGORY = gql`
  mutation updateVideoCategory($updateVideoCategoryInputFieldName: UpdateVideoCategoryInput!) {
    updateVideoCategory(updateVideoCategoryInputFieldName: $updateVideoCategoryInputFieldName) {
      id
    }
  }
`

export const BULK_UPDATE_VIDEO_CATEGORY = gql`
  mutation bulkUpdateVideoCategory($input: [BulkUpdateVideoCategoryInput!]!) {
    bulkUpdateVideoCategory(bulkUpdateVideoCategoryInput: $input) {
      id
    }
  }
`
